<div class="row space-between">
    <h2>Customize the Invitation</h2>
    <rr-icon class="pointer close" name="close" (click)="close()"></rr-icon>
</div>
<div class="w100 col gap-8">
    <div class="col rolelist gap-4">
        <label class="w100 color-dark">Please select minimum one *</label>
        <fieldset class="w100 row gap-8 wrap-true">
            <legend>Employee Role</legend>
            @for (role of roles; track role.id) {
                <rr-checkbox
                    class="roleitem"
                    [disabled]="!!data.link"
                    [checked]="!data.link ? (role.active || false) : !!data.link.invitedRole?.includes(role.id)"
                    [(ngModel)]="role.active"
                    *ngIf="role.type === 'USER'">
                    {{ role.name }}
                </rr-checkbox>
            }
        </fieldset>

        @if (isStartupFounderSelected()) {
            <hr class="w100" />
            <fieldset class="w100 row gap-8 wrap-true">
                <legend>Available coaches</legend>
                <rr-select
                    [disabled]="!!data.link"
                    optionValue="id"
                    [required]="true"
                    [options]="coaches"
                    optionName="email"
                    optionValue="id"
                    [(ngModel)]="selectedCoach"
                ></rr-select>
            </fieldset>
        }

        <hr class="w100" />
        <fieldset class="w100 row gap-8 wrap-true">
            <legend>User verification</legend>
            @for (inviteVerification of inviteVerifications; track $index) {
                <rr-checkbox
                    class="roleitem"
                    (click)="
                        selectInviteVerification(
                            inviteVerification.verification
                        )
                    "
                    [disabled]="!!data.link"
                    [checked]="!data.link ? inviteVerification.active : data.link.invitationProcessType === inviteVerification.verification"
                    [(ngModel)]="inviteVerification.active"
                >
                    {{ inviteVerification.verification }}
                </rr-checkbox>
            }
        </fieldset>

        <!--<hr class="w100" />
        <fieldset class="w100 row gap-8 wrap-true">
            <legend>System Roles</legend>
            @for (role of roles; track role.id) {
                <rr-checkbox
                    class="roleitem"
                    [checked]="role.active || false"
                    [(ngModel)]="role.active"
                    *ngIf="role.type === 'SYSTEM'"
                    >{{ role.name }}</rr-checkbox
                >
            }
        </fieldset>-->

        @if (data.companyData.userGates == true) {
            <hr class="w100" />
            <div class="row space-between w100 align-center">
                <div class="col">
                    <span> Create or Edit Usergates </span>
                    @if (usergateConfig) {
                        <span
                            >configured gates: {{ usergateConfig.length }}</span
                        >
                    }
                </div>
                <rr-btn type="Secondary" size="Small" (click)="openUserGates()"
                    >User Gates</rr-btn
                >
            </div>
        }
        @if (data.companyData.customLoginForm == true) {
            <hr class="w100" />
            <div class="row space-between w100 align-center">
                <div>Create or Edit Login Form</div>
                <rr-btn type="Secondary" size="Small" (click)="openLoginForm()">Login Form</rr-btn>
            </div>
        }
    </div>

    @if (!data.link) {
        <rr-input label="Expire Date" type="date" [min]="minDate" [(ngModel)]="expire"></rr-input>
    } @else {
        <div>
            Expiry Date:
            <span>
                @if (!data.link.expire) {
                    Never
                } @else {
                    {{ data.link.expire | date: 'dd.MM.yyyy' }}
                }
            </span>
        </div>
    }
</div>
<div class="row gap-8 justify-end">
    <rr-btn type="Secondary" size="Medium" (click)="close()">Cancel</rr-btn>
    <rr-btn type="Primary" size="Medium" (click)="generate()">Generate</rr-btn>
</div>
